import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/accreditations`;
const token = localStorage.getItem("token");

/// POST
export const addAccreditation = async (accreditation) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addAccreditation`,
      accreditation,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'accréditation :", error);
    throw error;
  }
};

/// GET
export const checkAccessToken = async (tokenParam) => {
  try {
    const response = await axios.get(
      `${apiUrl}/checkAccessToken/${tokenParam}`
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la vérification du token d'accès :", error);
    throw error;
  }
};

export const getAccreditationsByCompetition = async (competitionId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/byCompetition/${competitionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des accréditations :", error);
    throw error;
  }
};

/// DELETE
export const deleteAccreditation = async (accreditationId) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${accreditationId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'accréditation :", error);
    throw error;
  }
};
